import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SummaryState {
    hasPreparationFailed: boolean;
    isPreparing: boolean;
    fetchReservationPricesTimeoutId: number | null;
}

const initialState: SummaryState = {
    hasPreparationFailed: false,
    isPreparing: false,
    fetchReservationPricesTimeoutId: null,
};

const summarySlice = createSlice({
    name: 'summary',
    initialState,
    reducers: {
        summaryPreparationStarted: (state) => {
            state.hasPreparationFailed = false;
            state.isPreparing = true;
        },
        summaryPreparationSucceeded: (state) => {
            state.hasPreparationFailed = false;
            state.isPreparing = false;
        },
        summaryPreparationFailed: (state) => {
            state.hasPreparationFailed = true;
            state.isPreparing = false;
        },
        setFetchReservationPricesTimeoutId: (state, { payload: timeoutId }: PayloadAction<number | null>) => ({
            ...state,
            fetchReservationPricesTimeoutId: timeoutId,
        }),
    },
});

const {
    summaryPreparationSucceeded,
    summaryPreparationFailed,
    summaryPreparationStarted,
    setFetchReservationPricesTimeoutId,
} = summarySlice.actions;

export {
    summaryPreparationSucceeded,
    summaryPreparationFailed,
    summaryPreparationStarted,
    setFetchReservationPricesTimeoutId,
};

export const { reducer: summaryReducer } = summarySlice;
